let constants = /** @class */ (() => {
    class constants {
    }
    constants.NotificationTypes = class {
        static EntryApprovalNotificationId() {
            return "6E58213C-CF4A-48BC-A140-39AE6B31B38D".toLowerCase();
        }
        static EntryDeleteNotificationId() {
            return "3C684876-EF70-4282-B10B-51AFE64E8CA5".toLowerCase();
        }
        static EntryRequestNotificationId() {
            return "3A6E63D0-9A21-420A-9370-CBBE1DF029DA".toLowerCase();
        }
    };
    constants.CalenadarTypes = class {
        static Recurrence() {
            return 2;
        }
    };
    return constants;
})();
export { constants };
